import queryString from 'query-string'
import { get, set } from 'lodash'

const GET_PARTICIPANT_FOR_REVIEW = 'dofe-web/payment/GET_PARTICIPANT_FOR_REVIEW'
const GET_PARTICIPANT_FOR_REVIEW_SUCCESS =
  'dofe-web/payment/GET_PARTICIPANT_FOR_REVIEW_SUCCESS'
const GET_PARTICIPANT_FOR_REVIEW_FAIL =
  'dofe-web/payment/GET_PARTICIPANT_FOR_REVIEW_FAIL'

const UPDATE_PARTICIPANT_INFO = 'dofe-web/payment/UPDATE_PARTICIPANT_INFO'
const UPDATE_PARTICIPANT_INFO_SUCCESS =
  'dofe-web/payment/UPDATE_PARTICIPANT_INFO_SUCCESS'
const UPDATE_PARTICIPANT_INFO_FAIL =
  'dofe-web/payment/UPDATE_PARTICIPANT_INFO_FAIL'

const CHECK_AUTH_CODE = 'dofe-web/payment/CHECK_AUTH_CODE'
const CHECK_AUTH_CODE_SUCCESS = 'dofe-web/payment/CHECK_AUTH_CODE_SUCCESS'
const CHECK_AUTH_CODE_FAIL = 'dofe-web/payment/CHECK_AUTH_CODE_FAIL'

const GET_MC_SESSION = 'dofe-web/payment/GET_MC_SESSION'
const GET_MC_SESSION_SUCCESS = 'dofe-web/payment/GET_MC_SESSION_SUCCESS'
const GET_MC_SESSION_FAIL = 'dofe-web/payment/GET_MC_SESSION_FAIL'

const INIT_GP = 'dofe-web/payment/INIT_GP'
const INIT_GP_SUCCESS = 'dofe-web/payment/INIT_GP_SUCCESS'
const INIT_GP_FAIL = 'dofe-web/payment/INIT_GP_FAIL'

const PROCESS_GP = 'dofe-web/payment/PROCESS_GP'
const PROCESS_GP_SUCCESS = 'dofe-web/payment/PROCESS_GP_SUCCESS'
const PROCESS_GP_FAIL = 'dofe-web/payment/PROCESS_GP_FAIL'

const INIT_GP_WP = 'dofe-web/payment/INIT_GP_WP'
const INIT_GP_WP_SUCCESS = 'dofe-web/payment/INIT_GP_WP_SUCCESS'
const INIT_GP_WP_FAIL = 'dofe-web/payment/INIT_GP_WP_FAIL'

const PROCESS_GP_WP = 'dofe-web/payment/PROCESS_GP_WP'
const PROCESS_GP_WP_SUCCESS = 'dofe-web/payment/PROCESS_GP_WP_SUCCESS'
const PROCESS_GP_WP_FAIL = 'dofe-web/payment/PROCESS_GP_WP_FAIL'

const SET_PAYMENT_RESPONSE = 'dofe-web/payment/SET_PAYMENT_RESPONSE'
const SET_PAYMENT_RESPONSE_SUCCESS =
  'dofe-web/payment/SET_PAYMENT_RESPONSE_SUCCESS'
const SET_PAYMENT_RESPONSE_FAIL = 'dofe-web/payment/SET_PAYMENT_RESPONSE_FAIL'

const CREATE_PAYPAL_PAYMENT = 'dofe-web/payment/CREATE_PAYPAL_PAYMENT'
const CREATE_PAYPAL_PAYMENT_SUCCESS =
  'dofe-web/payment/CREATE_PAYPAL_PAYMENT_SUCCESS'
const CREATE_PAYPAL_PAYMENT_FAIL = 'dofe-web/payment/CREATE_PAYPAL_PAYMENT_FAIL'

const EXECURE_PAYPAL_PAYMENT = 'dofe-web/payment/EXECURE_PAYPAL_PAYMENT'
const EXECURE_PAYPAL_PAYMENT_SUCCESS =
  'dofe-web/payment/EXECURE_PAYPAL_PAYMENT_SUCCESS'
const EXECURE_PAYPAL_PAYMENT_FAIL =
  'dofe-web/payment/EXECURE_PAYPAL_PAYMENT_FAIL'

const SET_PAYMENT_METHOD = 'dofe-web/payment/SET_PAYMENT_METHOD'

const initialState = {
  participant: {
    data: null,
    isLoading: false
  },
  masterCard: {
    data: null,
    isLoading: false
  },
  globalPayments: {
    data: null,
    isLoading: false
  },
  paymentMethod: null
}

const createStateFactory = state => (key, { isLoading, data }) => ({
  ...state,
  [key]: {
    ...state[key],
    isLoading,
    data: data || (state[key] && state[key].data)
  }
})

const normalizeParticipant = participant => {
  const level = get(participant, 'previousCompletedAwardLevel.value')

  return set(
    participant,
    'helpers.previousCompletedAward.value',
    level ? 'yes' : 'no'
  )
}

export default function paymentReducer(state = initialState, action) {
  const createState = createStateFactory(state)

  switch (action.type) {
    case GET_PARTICIPANT_FOR_REVIEW:
      return createState('participant', { isLoading: true })

    case GET_PARTICIPANT_FOR_REVIEW_FAIL:
      return createState('participant', { isLoading: false })

    case GET_PARTICIPANT_FOR_REVIEW_SUCCESS:
      return createState('participant', {
        isLoading: false,
        data: normalizeParticipant(action.result)
      })

    case GET_MC_SESSION:
      return createState('masterCard', { isLoading: true })

    case GET_MC_SESSION_FAIL:
      return createState('masterCard', { isLoading: false })

    case GET_MC_SESSION_SUCCESS:
      return createState('masterCard', {
        isLoading: false,
        data: action.result
      })


    case INIT_GP:
      return createState('globalPayments', { isLoading: true })

    case INIT_GP_FAIL:
      return createState('globalPayments', { isLoading: false })

    case INIT_GP_SUCCESS:
      return createState('globalPayments', {
        isLoading: false,
        data: action.result
      })

    case SET_PAYMENT_METHOD:
      return { ...state, paymentMethod: action.id }

    default:
      return state
  }
}

export const getParticipantByAuthCode = authorizationCode => ({
  types: [
    GET_PARTICIPANT_FOR_REVIEW,
    GET_PARTICIPANT_FOR_REVIEW_SUCCESS,
    GET_PARTICIPANT_FOR_REVIEW_FAIL
  ],
  promise: client =>
    client.get(
      'api/participant-registrations/using-authorization-code?' +
        queryString.stringify({
          authorizationCode,
          with: ['PARTICIPANT_REGISTRATION_FOR_PARENT_GUARDIAN']
        }),
      {
        removeToken: true
      }
    )
})

export const updateParticipantInfo = (data, authorizationCode) => ({
  types: [
    UPDATE_PARTICIPANT_INFO,
    UPDATE_PARTICIPANT_INFO_SUCCESS,
    UPDATE_PARTICIPANT_INFO_FAIL
  ],
  promise: client =>
    client.post(
      'api/participant-registrations/using-authorization-code?' +
        queryString.stringify({ authorizationCode }),
      {
        data,
        removeToken: true
      }
    )
})

export const checkAuthCode = authorizationCode => ({
  types: [CHECK_AUTH_CODE, CHECK_AUTH_CODE_SUCCESS, CHECK_AUTH_CODE_FAIL],
  promise: client =>
    client.post(
      'api/participant-registrations/payment-link-expirations?' +
        queryString.stringify({ authorizationCode }),
      {
        removeToken: true
      }
    )
})

export const getMasterCardSession = authorizationCode => ({
  types: [GET_MC_SESSION, GET_MC_SESSION_SUCCESS, GET_MC_SESSION_FAIL],
  promise: client =>
    client.post(
      'api/mpg-init-sessions?' + queryString.stringify({ authorizationCode }),
      {
        removeToken: true
      }
    )
})

export const initGlobalPayments = (authorizationCode, responseUrl) => ({
  types: [INIT_GP, INIT_GP_SUCCESS, INIT_GP_FAIL],
  promise: client =>
    client.post(
      'api/gpg/init?' + queryString.stringify({ authorizationCode }),
      {
        removeToken: true,
        data: {
          responseUrl
        }
      }
    )
})

export const processGlobalPayments = (authorizationCode, data) => ({
  types: [PROCESS_GP, PROCESS_GP_SUCCESS, PROCESS_GP_FAIL],
  promise: client =>
    client.post(
      'api/gpg/process?' + queryString.stringify({ authorizationCode }),
      {
        removeToken: true,
        data
      }
    )
})

export const initGpWp = (authorizationCode, responseUrl) => ({
  types: [INIT_GP_WP, INIT_GP_WP_SUCCESS, INIT_GP_WP_FAIL],
  promise: client =>
    client.post(
      'api/gp/webpay/init?' + queryString.stringify({ authorizationCode }),
      {
        removeToken: true,
        data: {
          responseUrl
        }
      }
    )
})

export const processGpWp = (authorizationCode, data) => ({
  types: [PROCESS_GP_WP, PROCESS_GP_WP_SUCCESS, PROCESS_GP_WP_FAIL],
  promise: client =>
    client.post(
      'api/gp/webpay/process?' + queryString.stringify({ authorizationCode }),
      {
        data
      }
    )
})

export const setPaymentResponse = (authorizationCode, isPaid = true) => {
  return {
    types: [
      SET_PAYMENT_RESPONSE,
      SET_PAYMENT_RESPONSE_SUCCESS,
      SET_PAYMENT_RESPONSE_FAIL
    ],
    promise: client =>
      client.post(
        'api/mpg-store-response?' +
          queryString.stringify({ authorizationCode, isPaid }),
        {
          removeToken: true
        }
      )
  }
}

export const createPaypalPayment = authorizationCode => {
  return {
    types: [
      CREATE_PAYPAL_PAYMENT,
      CREATE_PAYPAL_PAYMENT_SUCCESS,
      CREATE_PAYPAL_PAYMENT_FAIL
    ],
    promise: client =>
      client.post(
        'api/paypal/create-payment?' +
          queryString.stringify({ authorizationCode }),
        {
          removeToken: true
        }
      )
  }
}

export const executePayment = (authorizationCode, data) => {
  return {
    types: [
      EXECURE_PAYPAL_PAYMENT,
      EXECURE_PAYPAL_PAYMENT_SUCCESS,
      EXECURE_PAYPAL_PAYMENT_FAIL
    ],
    promise: client =>
      client.post(
        'api/paypal/execute-payment?' +
          queryString.stringify({ authorizationCode }),
        {
          data,
          removeToken: true
        }
      )
  }
}

export const setPaymentMethod = id => ({
  type: SET_PAYMENT_METHOD,
  id
})
